module.exports = __webpack_public_path__ + "img/ig_polysulphide.8d4f8afa.png";